import { render, staticRenderFns } from "./AnswerValues.vue?vue&type=template&id=11e74a62&scoped=true"
import script from "./AnswerValues.vue?vue&type=script&lang=js"
export * from "./AnswerValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e74a62",
  null
  
)

export default component.exports